module.exports = __webpack_public_path__ + "static/img/top-img.fd3ec69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/top-img.jpg
// module id = +nk5
// module chunks = 51